import { createContext } from 'react';
import type { useDealController } from '@dealstack/frontend/app/pages/Project/DealDashboard/useDealController';

export const DealContext = createContext<ReturnType<typeof useDealController>>(
	{} as ReturnType<typeof useDealController>
);
